/* eslint-disable react-refresh/only-export-components */
import { clsx, type ClassValue } from "clsx"
import { animate, useMotionValue, useSpring } from "framer-motion";
import { useState, useEffect } from "react";
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("en-KE", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function AnimatedCounter({ end, suffix = "+", duration = 2.5 }: { end: number; suffix?: string; duration?: number }) {
  const count = useMotionValue(0);
  const rounded = useSpring(count, { stiffness: 60, damping: 15 });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(count, end, { duration });
    return controls.stop;
  }, [end, duration, count]);

  useEffect(() => {
    const unsubscribe = rounded.on("change", (v) => setDisplay(Math.round(v)));
    return () => unsubscribe();
  }, [rounded]);

  return (
    <span>
      {display}
      {suffix}
    </span>
  );
}